import type { ComponentChildren } from "preact";
import { type Inline, parseInline, parseRichText, richTextPlain } from "@fobu/engine";

/**
 * Formulartexte ohne innerHTML: Auszeichnung kommt aus dem gemeinsamen Parser (@fobu/engine).
 * Links nur mit http(s) und mailto; sie öffnen in neuem Tab mit rel=noopener.
 */
function inline(c: Inline[], key = ""): ComponentChildren[] {
  return c.map((x, i) => {
    const k = `${key}${i}`;
    switch (x.t) {
      case "text":
        return x.v;
      case "br":
        return <br key={k} />;
      case "b":
        return <strong key={k}>{inline(x.c, `${k}-`)}</strong>;
      case "i":
        return <em key={k}>{inline(x.c, `${k}-`)}</em>;
      case "s":
        return <s key={k}>{inline(x.c, `${k}-`)}</s>;
      case "a":
        return x.href ? (
          <a key={k} href={x.href} target="_blank" rel="noopener noreferrer">
            {inline(x.c, `${k}-`)}
          </a>
        ) : (
          <span key={k}>{inline(x.c, `${k}-`)}</span>
        );
    }
  });
}

/**
 * `as="span"`: nur Inline-Auszeichnung (Beschriftungen).
 * `as="p"`/`"div"`: Absätze und Listen (Textblöcke, Hinweise, Endseiten).
 */
export function Markdown({ text, as = "span" }: { text: string; as?: "span" | "div" | "p" }) {
  if (as === "span") return <span>{inline(parseInline(text))}</span>;
  const blocks = parseRichText(text).map((b, i) =>
    b.t === "p" ? (
      <p key={i}>{inline(b.c)}</p>
    ) : b.t === "ul" ? (
      <ul key={i} class="fb-list">
        {b.items.map((it, j) => (
          <li key={j}>{inline(it)}</li>
        ))}
      </ul>
    ) : (
      <ol key={i} class="fb-list" start={b.start}>
        {b.items.map((it, j) => (
          <li key={j}>{inline(it)}</li>
        ))}
      </ol>
    ),
  );
  return as === "div" ? <div class="fb-rich">{blocks}</div> : <>{blocks}</>;
}

/** Reiner Text ohne Markdown-Zeichen (für aria-label, <title>). */
export const plain = (text: string) => richTextPlain(text);
